import { useQuery } from '@tanstack/react-query';

import { getBusinessDistricts } from 'api/admin/businesses/businesses';

const formattedDistrictName = (district) => {
  if (!district) {
    return district;
  }

  return [district?.regionName?.toUpperCase() || '', district?.name || ''].join(': ');
};

const useDistricts = (businessId) => {
  const {
    isLoading,
    error,
    data = [],
  } = useQuery({
    queryKey: ['getBusinessDistricts', businessId],
    queryFn: async ({ queryKey }) => {
      const [, businessId] = queryKey;
      if (businessId) {
        const response = await getBusinessDistricts(businessId);
        const districts = response.data.districts;

        const mappedDistricts = districts.map((district) => ({
          display: formattedDistrictName(district),
          value: district.id,
        }));
        return mappedDistricts;
      } else {
        return [];
      }
    },
    retry: 1,
  });

  return {
    isLoading,
    error: error?.response?.data?.error ?? error?.message ?? null,
    data,
  };
};

export default useDistricts;
